export const CONSENT_KEY = "sdgp_chat_consent";
export const TOOLTIP_KEY = "sdgp_chat_tooltip_dismissed";
export const MAX_LEN = 200;